import { useProfileData } from "./useProfileData";

const useIsOwn = ({ userId, isUserDataLoading }: { userId?: number; isUserDataLoading: boolean }) => {
  const {
    data: { id: ownUserId },
    isLoading: isProfileDataLoading,
  } = useProfileData();

  return {
    isOwn: ownUserId === userId,
    isLoading: isProfileDataLoading || isUserDataLoading,
  };
};

export default useIsOwn;
